import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import _ from "lodash";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import {
  selectCheckoutInfo,
  // selectEstimatedTotal,
  selectBillingAddress,
  selectCheckoutShipping,
} from "../../redux/checkout/checkout.selectors";

import withAuth from "../../hocs/withAuth";

import useStyles from "./checkout-confirm.styles";

import CheckoutSummary from "../../components/checkout-summary";
import Loading from "../../components/loading";
import StripeIcon from "../../assets/icons/stripe-icon";

const CheckoutConfirmPage = () => {
  // const estimatedTotal = useSelector(selectEstimatedTotal);
  const { contact, shippingAddress } = useSelector(selectCheckoutInfo);
  const { email } = contact;
  const billingAddress = useSelector(selectBillingAddress);
  const checkoutShipping = useSelector(selectCheckoutShipping);
  const [orderNum, setOrderNum] = useState<string>("10001");

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 500);

    window.scrollTo({
      top: 0,
    });
  }, []);

  const matches = useMediaQuery("(min-width:1200px)");

  const classes = useStyles({ matches });

  return (
    <div className={classes.container}>
      <Link to="/" className={classes.logo}>
        LOGO
      </Link>
      <div className={classes.subContainer}>
        <div className={classes.orderNumber}>Order #{orderNum}</div>
        <div className={classes.thankYouForOrder}>Thank you for order</div>
        <div className={classes.sectionContainer}>
          <div className={`${classes.sectionTitle} ${classes.orderUpdates}`}>
            Order Updates
          </div>
          <div className={classes.sectionContent}>
            You will get shipping and delivery updates by email{" "}
            <span className={classes.email}>{email}</span>
          </div>
        </div>
        <div className={classes.sectionContainer}>
          <div className={classes.sectionTitle}>Payment Method</div>
          <div className={classes.sectionContent}>
            Ending with <span>4242</span> - CAD $
            {/* {estimatedTotal && typeof estimatedTotal === "number"
              ? estimatedTotal.toFixed(2)
              : "-"} */}
          </div>
        </div>
        <div className={classes.sectionContainer}>
          <div className={classes.sectionTitle}>Customer Information</div>
          <div className={classes.sectionContentCotainer}>
            <div className={classes.subSectionContainer}>
              <div className={classes.subSectionTitle}>Contact Information</div>
              <div className={classes.subSectionContent}>{email}</div>
            </div>
            <div className={classes.subSectionContainer}>
              <div className={classes.subSectionTitle}>Shipping Address</div>
              <div className={classes.subSectionContent}>
                <div>{`${shippingAddress.firstname} ${shippingAddress.lastname}`}</div>
                <div>{`${shippingAddress.line1}, ${shippingAddress.city}, ${shippingAddress.state} ${shippingAddress.postal_code}, ${shippingAddress.country}`}</div>
                <div>{shippingAddress.phone}</div>
              </div>
            </div>
            <div className={classes.subSectionContainer}>
              <div className={classes.subSectionTitle}>Billing Address</div>
              <div className={classes.subSectionContent}>
                <div>{`${billingAddress.firstname ?? ""} ${
                  billingAddress.lastname ?? ""
                }`}</div>
                <div>{`${
                  billingAddress.line1 ? `${billingAddress.line1},` : ""
                } ${billingAddress.city ? `${billingAddress.city},` : ""} ${
                  billingAddress.state ?? ""
                } ${
                  billingAddress.postal_code
                    ? `${billingAddress.postal_code},`
                    : ""
                } ${billingAddress.country ?? ""}`}</div>
                <div>{billingAddress.phone ?? ""}</div>
              </div>
            </div>
            <div className={classes.subSectionContainer}>
              <div className={classes.subSectionTitle}>Shipping Method</div>
              <div className={classes.subSectionContent}>
                {_.startCase(checkoutShipping.method)}{" "}
                {checkoutShipping.price === 0
                  ? "FREE"
                  : `CAD $${checkoutShipping.price}`}
              </div>
            </div>
          </div>
        </div>
        <div className={classes.btnContainer}>
          <StripeIcon height="0" />
          <Link to="/" className={classes.continueBtn}>
            Continue Shopping
          </Link>
        </div>
      </div>
      <CheckoutSummary />
      <Loading size="3rem" fullScreen on={isLoading} />
    </div>
  );
};

export default withAuth(CheckoutConfirmPage);
